import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import {
  FDLetterhead, FDContentContainer, FDStack, FDBox,
} from '@facet-wealth/design';
import {
  WhatIfScenarioAssumptionsClientDisclaimer,
} from 'Components/ComponentLibrary/Organisms/WhatIfScenarioAssumptionsClientDisclaimer';
import WhatIfClientDisclaimerContainer
  from 'Components/ComponentLibrary/Organisms/WhatIfClientDisclaimer/WhatIfClientDisclaimerContainer';

const Content = () => {
  const {
    resource,
  } = useMetaLayoutContext();

  return (
    <PageContentContainer>
      <PageContentTop
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <FDLetterhead
        image={resource.relationship(fr.relationships.plannerProfileImage.name)?.link('related').url()}
        title={resource.attr('plannerDisplayName')}
      >
        <RichTextDisplay content={resource.attr('commonInsights')} />
      </FDLetterhead>

      <FDBox margin={400}>
        <FDContentContainer maxWidth={'sm'}>
          <FDStack direction={'column'} spacing={2} alignItems={'center'} justifyContent="flex-start">
            <WhatIfScenarioAssumptionsClientDisclaimer resource={resource} />
            <WhatIfClientDisclaimerContainer />
          </FDStack>
        </FDContentContainer>
      </FDBox>
    </PageContentContainer>
  );
};

export default Content;
